"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgMyLocation(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M13 0v1.324A6.755 6.755 0 0118.677 7H20v2h-1.324A6.755 6.755 0 0113 14.676V16h-2v-1.324A6.755 6.755 0 015.324 9H4V7h1.323a6.755 6.755 0 015.678-5.677L11 0zm0 2.845V4h-2V2.845a5.256 5.256 0 00-4.155 4.156L8 7v2H6.845A5.256 5.256 0 0011 13.155V12h2v1.155A5.256 5.256 0 0017.155 9H16V7h1.155A5.256 5.256 0 0013 2.846zM12 6a2 2 0 110 4 2 2 0 010-4z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('MyLocation')(SvgMyLocation);
//# sourceMappingURL=MyLocation.js.map